// extracted by mini-css-extract-plugin
export default {"brandPromo":"IH-z","carousel":"JH-z"};